import { AffectedValueProps } from 'components/CIMSModal/WorkflowRollbackModal/components/AffectedValues/components/AffectedValue/types'
import { Issue } from '../../IssueTrackerContext/types'
import { dateFormatter } from '../../../../../../../../../utils/dateFormatter'

type AffectedValuePropsFn = (
  issue: Issue,
  hidden?: Pick<AffectedValueProps, 'hidden'>
) => AffectedValueProps[]

export const draftAffectedItems: AffectedValuePropsFn = (
  { submittedBy, submittedDate },
  hidden
) => [
  {
    label: 'Submitted By',
    value: submittedBy?.displayName ?? submittedBy?.mail,
    ...hidden,
  },
  {
    label: 'Submitted Date',
    value: dateFormatter.datetime(submittedDate),
    ...hidden,
  },
]

export const pendingResponseAffectedItems: AffectedValuePropsFn = (
  { responseBy, responseDate },
  hidden
) => [
  {
    label: 'Response By',
    value: responseBy?.displayName ?? responseBy?.mail,
    ...hidden,
  },
  {
    label: 'Response Date',
    value: dateFormatter.datetime(responseDate),
    ...hidden,
  },
]

export const pendingDispositionAffectedItems: AffectedValuePropsFn = (
  { dispositionType, dispositionBy, dispositionDate },
  hidden
) => [
  {
    label: 'Disposition',
    value: dispositionType?.name,
    ...hidden,
  },
  {
    label: 'Disposition By',
    value: dispositionBy?.displayName ?? dispositionBy?.mail,
    ...hidden,
  },
  {
    label: 'Disposition Date',
    value: dateFormatter.datetime(dispositionDate),
    ...hidden,
  },
]
